// 📄 activacionService.ts
// Enlace de activación propio de las invitaciones (2026-10-26): el correo
// de bienvenida lleva a /activar?codigo=… (vence en 7 días, un solo uso).
// Ver functions/callable/activarCuenta.js y reenviarInvitacion.js.
import { httpsCallable } from 'firebase/functions';
import { doc, getDoc } from 'firebase/firestore';
import { db, functionsClient } from '../firebase';

export const PASSWORD_MIN = 8;

export interface DatosActivacion {
  email: string;
  nombre: string;
  invitacion: string;
}

export const consultarActivacion = async (codigo: string): Promise<DatosActivacion> => {
  const callable = httpsCallable(functionsClient, 'activarCuenta');
  const result = await callable({ accion: 'consultar', codigo });
  return result.data as DatosActivacion;
};

export const activarCuenta = async (codigo: string, password: string): Promise<{ email: string }> => {
  const callable = httpsCallable(functionsClient, 'activarCuenta');
  const result = await callable({ accion: 'activar', codigo, password });
  return result.data as { email: string };
};

/** Nuevo correo de bienvenida (el enlace anterior deja de servir). */
export const reenviarInvitacion = async (destino: { email: string; projectId?: string; orgId?: string }) => {
  const callable = httpsCallable(functionsClient, 'reenviarInvitacion');
  await callable({ ...destino, appUrl: window.location.origin });
};

/** De estos uids, cuáles fueron invitados y todavía no crearon su contraseña. */
export const getUidsSinActivar = async (uids: string[]): Promise<Set<string>> => {
  const snaps = await Promise.all(uids.map((uid) => getDoc(doc(db, 'activacionesPendientes', uid)).catch(() => null)));
  return new Set(snaps.filter((s) => s?.exists()).map((s) => s!.id));
};
